import { afterNextRender, effect, inject, Injector } from '@angular/core';

/**
 * For custom previous/next pagers: the pressed button gets disabled on the
 * first or last page, which drops focus to the body. After the page changes,
 * focus moves to the other pager button instead.
 *
 * Call in an injection context; pass the returned function the click event
 * of a pager button.
 */
export function pagerFocusKeeper(page: () => number): (event: Event) => void {
  const injector = inject(Injector);
  let pressed: HTMLButtonElement | null = null;

  effect(() => {
    page();
    const button = pressed;
    if (!button) return;
    pressed = null;
    afterNextRender(
      () => {
        if (!button.disabled) return;
        button
          .closest('app-m3-icon-button')
          ?.parentElement?.querySelector<HTMLButtonElement>(
            'app-m3-icon-button button:not(:disabled)'
          )
          ?.focus();
      },
      { injector }
    );
  });

  return (event: Event) => {
    pressed = (event.target as HTMLElement).closest('button');
  };
}
